import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: François Risoud
 * id DE87F14C-101D-47F2-87C5-118BE76F7C58
 * name map-marker-alert
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-alert.svg
 * tags
 * - Navigation 
 * - Alert / Error 
 * - Geographic Information System 
 */
export const MapMarkerAlertIcon = createSvgIcon(<><path d="M12 2C15.9 2 19 5.1 19 9C19 14.2 12 22 12 22S5 14.2 5 9C5 5.1 8.1 2 12 2M11 6V12H13V6H11M11 14V16H13V14H11Z" /></>, 'MapMarkerAlertIcon');
export default MapMarkerAlertIcon